/* @flow */
import React from 'react';
import capitalize from 'utils/capitalize';
import invariant from 'invariant';
import OrganizationStore from 'stores/OrganizationStore';
import ProfilePicture from 'user/components/ProfilePicture.jsx';
import Relationship from 'entities/Relationship';
import Subscriber from 'entities/Subscriber';
import Text from 'components/Text.jsx';

import './styles/RelationshipViewProfileHeader.scss';

class RelationshipViewProfileHeader extends React.Component {
  static propTypes = {
    relationship: React.PropTypes.instanceOf(Relationship).isRequired,
    subscriber: React.PropTypes.instanceOf(Subscriber).isRequired,
  };

  renderOrgAffiliations() {
    const orgAffiliations = this.props.relationship.getOrgAffiliationViews();
    return (
      <div>
        {orgAffiliations.map(orgAff => {
          const org = OrganizationStore.getOrganization(orgAff.organization_id);
          invariant(org, 'missing organization');
          return <Text element="div">{capitalize(orgAff.roles.join(', '))} at {org.getName()}</Text>;
        })}
      </div>
    );
  }

  renderOfficeHours() {
    const officeHours = this.props.subscriber.getOfficeHours();
    if (!officeHours || !officeHours.hasAvailability()) {
      return null;
    }
    return this.renderSecondaryByline(`Office hours: ${officeHours.getLabel()}`);
  }

  renderMediums() {
    const { subscriber } = this.props;
    const enabledDevices = subscriber.getDevices().filter(device => device.isEnabled());
    if (enabledDevices.length === 0) {
      return null;
    }

    const text = `Receiving messages via ${enabledDevices.map(d => d.getFriendlyName()).join(', ').toLowerCase()}`;
    return this.renderSecondaryByline(text);
  }

  renderSecondaryByline(text: string) {
    return <Text element="div" size="xsmall" color="thunder">{text}</Text>;
  }

  render() {
    const { subscriber } = this.props;
    return (
      <div className="RelationshipViewProfileHeader">
        <ProfilePicture user={subscriber} />
        <Text element="div" size="xxxlarge">{subscriber.getName()}</Text>
        {this.renderOrgAffiliations()}
        <div className="RelationshipViewProfileHeader-subtext">
          {this.renderOfficeHours()}
          {this.renderMediums()}
        </div>
      </div>
    );
  }
}

export default RelationshipViewProfileHeader;



// WEBPACK FOOTER //
// ./src/user/components/RelationshipViewProfileHeader.jsx